

export class VehicleDetailsSelectByCompanyDetailsIdOutputData implements IVehicleDetailsSelectByCompanyDetailsIdOutputData {
    /** The auto-generated id of the tbl vehicle details master */
    vehicle_details_id!: number;
    /** The vehicle number with vehicle name */
    vehicle_name_number!: string;
    /** The vehicle model with 255 character */
    vehicle_model_name!: string;
    /** The vehicle type name with 255 character */
    vehicle_type_name!: string;
    /** The vehicle odometer */
    odometer!: number;
    /** The vehicle moveable or immovable */
    vehicle_category!: string;
    /** The vehicle special feature */
    special_feature!: string;
    /** The manufacturing date with 10 character limit */
    manufacture_date!: string;
    /** The vehicle company name with 50 character limit */
    vehicle_company_name!: string;

    constructor(data?: IVehicleDetailsSelectByCompanyDetailsIdOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicle_details_id = _data["vehicle_details_id"];
            this.vehicle_name_number = _data["vehicle_name_number"];
            this.vehicle_model_name = _data["vehicle_model_name"];
            this.vehicle_type_name = _data["vehicle_type_name"];
            this.odometer = _data["odometer"];
            this.vehicle_category = _data["vehicle_category"];
            this.special_feature = _data["special_feature"];
            this.manufacture_date = _data["manufacture_date"];
            this.vehicle_company_name = _data["vehicle_company_name"];
        }
    }

    static fromJS(data: any): VehicleDetailsSelectByCompanyDetailsIdOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDetailsSelectByCompanyDetailsIdOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicle_details_id"] = this.vehicle_details_id;
        data["vehicle_name_number"] = this.vehicle_name_number;
        data["vehicle_model_name"] = this.vehicle_model_name;
        data["vehicle_type_name"] = this.vehicle_type_name;
        data["odometer"] = this.odometer;
        data["vehicle_category"] = this.vehicle_category;
        data["special_feature"] = this.special_feature;
        data["manufacture_date"] = this.manufacture_date;
        data["vehicle_company_name"] = this.vehicle_company_name;
        return data; 
    }
}

export interface IVehicleDetailsSelectByCompanyDetailsIdOutputData {
    /** The auto-generated id of the tbl vehicle details master */
    vehicle_details_id: number;
    /** The vehicle number with vehicle name */
    vehicle_name_number: string;
    /** The vehicle model with 255 character */
    vehicle_model_name: string;
    /** The vehicle type name with 255 character */
    vehicle_type_name: string;
    /** The vehicle odometer */
    odometer: number;
    /** The vehicle moveable or immovable */
    vehicle_category: string;
    /** The vehicle special feature */
    special_feature: string;
    /** The manufacturing date with 10 character limit */
    manufacture_date: string;
    /** The vehicle company name with 50 character limit */
    vehicle_company_name: string;
}

